module.exports = __webpack_public_path__ + "static/media/AgriStackCloud - GBR Network - 01-04-2025 C.824caad3.gif";